import type { HistoricalData } from '@/queries/historical.query'
import { formatDate } from '@vaultsfyi/common/utils'
import { Separator } from '../common/separator'
import { IntrinsicIcon } from '../icons/intrinsic'
import { RewardsIcon } from '../icons/rewards'
import { ChartTooltip } from './chartTooltip'

type ProcessedDataPoint = HistoricalData[number] & { intrinsicApy: number | null }

interface ApyChartTooltip {
  data: ProcessedDataPoint
}

export const ApyChartTooltip = ({ data }: ApyChartTooltip) => {
  if (!data) {
    return null
  }

  return (
    <ChartTooltip>
      <div className="flex flex-col gap-1">
        <span>{formatDate({ timestamp: data.timestamp, showYear: true })}</span>
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
          <div className="flex items-center gap-1">
            <span className="font-semibold">Base</span>
          </div>
          <span className="ml-auto font-bold tabular-nums">{data.base.toFixed(2)}%</span>
        </div>
        {data.intrinsicApy != null && (
          <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
            <div className="flex items-center gap-1">
              <IntrinsicIcon className="text-[rgb(var(--chart-cyan))]" />
              <span className="font-semibold">Intrinsic</span>
            </div>
            <span className="ml-auto font-bold tabular-nums">{data.intrinsicApy.toFixed(2)}%</span>
          </div>
        )}
        {Boolean(data.reward) && (
          <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
            <div className="flex items-center gap-1">
              <RewardsIcon className="text-[rgb(var(--chart-violet))]" />
              <span className="font-semibold">Rewards</span>
            </div>
            <span className="ml-auto font-bold tabular-nums">{data.reward.toFixed(2)}%</span>
          </div>
        )}
        <Separator className="my-2" />
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1 font-bold">
          <span>Total</span>
          <span className="ml-auto tabular-nums">{data.total.toFixed(2)}%</span>
        </div>
      </div>
    </ChartTooltip>
  )
}
